import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '../../../../core/services/config.service';
import { fuseAnimations } from '../../../../core/animations';
import * as firebase from 'firebase';
import { Router } from "@angular/router";
import { AngularFirestore } from 'angularfire2/firestore';
import { Http } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'fuse-login-2',
    templateUrl: './login-2.component.html',
    styleUrls: ['./login-2.component.scss'],
    animations: fuseAnimations
})
export class FuseLogin2Component implements OnInit {
    loginForm: FormGroup;
    loginFormErrors: any;
    model: any;
    alert: any;
    ipAddress: any;
    alert2: any;
    subscription = new Subscription();
    constructor(
        private fuseConfig: FuseConfigService,
        private formBuilder: FormBuilder,
        private _http: Http,
        private afs: AngularFirestore,
        private router: Router,
    ) {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });

        this.loginFormErrors = {
            email: {},
            password: {}
        };
    }

    ngOnInit() {
        this.getIpAdress();
        this.loginForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });

        this.loginForm.valueChanges.subscribe(() => {
            this.onLoginFormValuesChanged();
        });
    }

    onLoginFormValuesChanged() {
        for (const field in this.loginFormErrors) {
            if (!this.loginFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.loginFormErrors[field] = control.errors;
            }
        }
    }

    getIpAdress() {
        this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
            .map(data => { this.ipAddress = data.json() }).subscribe());
    }

    async login(form) {
        if (form) {
            firebase.auth().signInWithEmailAndPassword(form.email, form.password).then(data => {
                localStorage.setItem('currentUserId', data['uid']);
                this.afs.collection('adminUsers').doc(data['uid']).ref.get().then(isAdmin => {
                    localStorage.setItem('currentUserRole', isAdmin.data().roles);
                    if (isAdmin.exists && isAdmin.data().roles) {
                        this.afs.collection('logs').add({
                            userId: data['uid'],
                            date: new Date(),
                            type: 'login',
                            ipAddress: this.ipAddress,
                            url: 'console.bigadvice.com'
                        })
                        this.router.navigate(['/dashboard']);
                    }
                    else {
                        this.alert = '';
                        this.alert2 = "Rol tanımlı değil!"
                        firebase.auth().signOut();
                        localStorage.clear();
                    }
                });
                // firebase.database().ref().child('adminUsers').child(data['uid']).once('value', isAdmin => {
                //     localStorage.setItem('currentUserRole', isAdmin.val().roles);

                //     if (isAdmin.val().roles) {
                //         console.log("giriş")
                //         this.router.navigate(['/dashboard']);
                //     } else {
                //         this.alert = '';
                //         this.alert2 = "Rol tanımlı değil!"
                //         firebase.auth().signOut();
                //         localStorage.clear();
                //     }
                // });
            },
                (err: firebase.FirebaseError) => {
                    switch (err.code) {

                        case "auth/user-not-found": this.alert = "Bu kullanıcı Yönetici Paneline giriş için yetkili değildir. Sadece yetkilendirilen hesaplar, kendi rollerine tanımlanan yetkiyle giriş yapabilir."; break;
                        case "auth/invalid-email": this.alert = "E-posta adresi hatalı biçimlendirilmiş."; break;
                        case "auth/wrong-password": this.alert = "Parola geçersiz veya kullanıcının şifresi yok."; break;
                        default: this.alert = "Hatalı giriş yaptınız."
                            this.alert2 = '';
                    }
                });

            // if(localStorage.getItem('currentUserRole') === 'undefined'){
            //     console.log("girdi");
            //     this.alert="jdflgj"
            // }
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/pages/login-2/login-2.component.ts